import {AnyAction} from 'redux'
import {DetailsPageComponent} from '../types/state'

const defaultState: DetailsPageComponent = {
  id: null,
  settings: {} as any,
}

export const component = (state = defaultState, action: AnyAction): DetailsPageComponent => {
  switch (action.type) {
    default:
      return state
  }
}
